import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextPanelComponent } from './text-panel.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { TextModule } from '../lib/ui-kit/text/text.module';

@NgModule({
  declarations: [TextPanelComponent],
  exports: [TextPanelComponent],
  imports: [
    CommonModule,
    SharedModule,
    TextModule
  ],
})
export class TextPanelModule { }
